import { HeartIcon } from '@heroicons/react/24/solid';

const TAX_REDUCTION = 0.66;
const amounts = [20, 50, 100];

const euros = (value: number) =>
  value.toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', minimumFractionDigits: value % 1 ? 2 : 0 });

const uses = [
  { title: 'Paniers repas', text: 'Plats, eau, jus, fruits et gâteaux distribués pendant nos maraudes.' },
  { title: 'Boissons chaudes et vêtements', text: "De quoi tenir dans la rue, surtout l'hiver." },
  { title: "Kits d'hygiène", text: 'Des produits de première nécessité pour prendre soin de soi.' },
];

const Donate = () => {
  return (
    <div className="container mx-auto px-4 py-20 md:py-24">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.2em] opacity-80 mb-3">Soutenir</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight leading-[1.1] mb-5">
            Votre don nourrit nos actions
          </h2>
          <p className="text-lg md:text-xl opacity-90 leading-relaxed mb-8">
            Chaque euro finance directement ce que nous distribuons. Le paiement est sécurisé via HelloAsso.
          </p>
          <ul className="space-y-4">
            {uses.map(use => (
              <li key={use.title} className="flex gap-3">
                <HeartIcon className="h-5 w-5 mt-1 shrink-0 text-[#B4463C]" />
                <p><span className="font-bold">{use.title}</span> : {use.text}</p>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-3xl bg-white text-[#2B1A18] p-6 sm:p-8 shadow-[0_16px_40px_-20px_rgb(0_0_0/0.25)]">
          <p className="font-bold text-lg mb-1">Ce que votre don vous coûte vraiment</p>
          <p className="text-sm text-[#2B1A18]/70 mb-6">
            Votre don ouvre droit à une réduction d'impôt de 66 % de son montant. Vous recevez un reçu fiscal.
          </p>
          <div className="grid grid-cols-3 gap-3 mb-8">
            {amounts.map(amount => (
              <div key={amount} className="rounded-2xl bg-[#FEF8E8] border border-[#2B1A18]/10 p-3 sm:p-4 text-center">
                <p className="text-2xl sm:text-3xl font-extrabold">{euros(amount)}</p>
                <p className="mt-1 text-xs sm:text-sm text-[#2B1A18]/70">
                  soit <span className="font-bold text-[#B4463C]">{euros(Math.round(amount * (1 - TAX_REDUCTION) * 100) / 100)}</span> après réduction
                </p>
              </div>
            ))}
          </div>
          <a
            href="https://www.helloasso.com/associations/nous-rire"
            target="_blank"
            rel="noopener noreferrer"
            className="btn w-full bg-[#2B1A18] text-white hover:bg-[#2B1A18]/90 py-4 text-lg"
          >
            <HeartIcon className="h-5 w-5 text-brand" /> Faire un don sur HelloAsso
          </a>
        </div>
      </div>
    </div>
  );
};

export default Donate;
